/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Email_Verification_EnabledInputs */

const en_admin_settings_fields_email_verification_enabled = /** @type {(inputs: Admin_Settings_Fields_Email_Verification_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Require email verification on sign up`)
};

const zh_admin_settings_fields_email_verification_enabled = /** @type {(inputs: Admin_Settings_Fields_Email_Verification_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册时需要邮箱验证`)
};

/**
* | output |
* | --- |
* | "Require email verification on sign up" |
*
* @param {Admin_Settings_Fields_Email_Verification_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_email_verification_enabled = /** @type {((inputs?: Admin_Settings_Fields_Email_Verification_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Email_Verification_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_email_verification_enabled(inputs)
	return zh_admin_settings_fields_email_verification_enabled(inputs)
});
export { admin_settings_fields_email_verification_enabled as "admin.settings.fields.email_verification_enabled" }